module.exports = __webpack_public_path__ + "img/v-white.ff90f2a4.svg";